// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_B25hF {
  width: 100%;
  margin: 0 auto;
  margin-top: 100px;
  padding: 50px 0;
  background: linear-gradient(180deg, var(--white-background) 0%, var(--f5-background) 100%);
  display: flex;
  justify-content: center;

  article {
    width: 70%;
    h2,
    span {
      margin: 0 auto;
    }
    p {
      margin: 5px;
      color: var(--_67-color);
    }

    h2 {
      color: var(--_18181b-color);
      font-size: 44px;
      font-family: Inter;
      font-weight: 500;
      line-height: 52.8px;
      word-wrap: break-word;
    }
    span {
      color: var(--_67-color);
      font-size: 20px;
      font-family: Inter;
      font-style: italic;
      font-weight: 300;
      line-height: 33px;
      word-wrap: break-word;
    }
    section {
      min-height: fit-content;
      align-items: start;
      gap: 0;
      margin: 20px 0;
      h3,
      h2,
      ul,
      p {
        margin: 5px;
        color: var(--_67-color);
      }
      a {
        color: var(--_10a37f-background);
      }
      li {
        list-style: disc;
      }
    }
  }
}
@media (max-width: 768px) {
  .main_B25hF {
    width: 100%;
    margin-top: 30px;
    article{
      width: 90%;
    }
  }
}
header {
  display: flex;
  flex-direction: column;
  gap: 20px;

  h2 {
    font-size: 32px;
    margin: 0;
  }
  span {
    font-size: 14px;
    color: #292929;
  }
  p {
    margin: 0;
    font-size: 14px;
    font-weight: bold;
  }
}

.termsandconditionsection_ebKPp {
  color: var(--292929-color);
  font-weight: 600;
  margin-top: 30px;
  a {
    color: var(--_16c098-color);
  }
  h3,
  h4 {
    margin: 0;
    font-size: 16px;
  }
  h4 {
    font-weight: 500;
  }
  ul {
    margin: 0;
    list-style-type: disc;
  }

  p {
    margin: 0;
    margin-bottom: 20px;
    font-weight: 500;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/Terms/TermsAndConditions.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,0FAA0F;EAC1F,aAAa;EACb,uBAAuB;;EAEvB;IACE,UAAU;IACV;;MAEE,cAAc;IAChB;IACA;MACE,WAAW;MACX,uBAAuB;IACzB;;IAEA;MACE,2BAA2B;MAC3B,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,qBAAqB;IACvB;IACA;MACE,uBAAuB;MACvB,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,qBAAqB;IACvB;IACA;MACE,uBAAuB;MACvB,kBAAkB;MAClB,MAAM;MACN,cAAc;MACd;;;;QAIE,WAAW;QACX,uBAAuB;MACzB;MACA;QACE,gCAAgC;MAClC;MACA;QACE,gBAAgB;MAClB;IACF;EACF;AACF;AACA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB;MACE,UAAU;IACZ;EACF;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,SAAS;IACT,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB;IACE,2BAA2B;EAC7B;EACA;;IAEE,SAAS;IACT,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,gBAAgB;EAClB;AACF","sourcesContent":[".main {\n  width: 100%;\n  margin: 0 auto;\n  margin-top: 100px;\n  padding: 50px 0;\n  background: linear-gradient(180deg, var(--white-background) 0%, var(--f5-background) 100%);\n  display: flex;\n  justify-content: center;\n\n  article {\n    width: 70%;\n    h2,\n    span {\n      margin: 0 auto;\n    }\n    p {\n      margin: 5px;\n      color: var(--_67-color);\n    }\n\n    h2 {\n      color: var(--_18181b-color);\n      font-size: 44px;\n      font-family: Inter;\n      font-weight: 500;\n      line-height: 52.8px;\n      word-wrap: break-word;\n    }\n    span {\n      color: var(--_67-color);\n      font-size: 20px;\n      font-family: Inter;\n      font-style: italic;\n      font-weight: 300;\n      line-height: 33px;\n      word-wrap: break-word;\n    }\n    section {\n      min-height: fit-content;\n      align-items: start;\n      gap: 0;\n      margin: 20px 0;\n      h3,\n      h2,\n      ul,\n      p {\n        margin: 5px;\n        color: var(--_67-color);\n      }\n      a {\n        color: var(--_10a37f-background);\n      }\n      li {\n        list-style: disc;\n      }\n    }\n  }\n}\n@media (max-width: 768px) {\n  .main {\n    width: 100%;\n    margin-top: 30px;\n    article{\n      width: 90%;\n    }\n  }\n}\nheader {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  h2 {\n    font-size: 32px;\n    margin: 0;\n  }\n  span {\n    font-size: 14px;\n    color: #292929;\n  }\n  p {\n    margin: 0;\n    font-size: 14px;\n    font-weight: bold;\n  }\n}\n\n.termsandconditionsection {\n  color: var(--292929-color);\n  font-weight: 600;\n  margin-top: 30px;\n  a {\n    color: var(--_16c098-color);\n  }\n  h3,\n  h4 {\n    margin: 0;\n    font-size: 16px;\n  }\n  h4 {\n    font-weight: 500;\n  }\n  ul {\n    margin: 0;\n    list-style-type: disc;\n  }\n\n  p {\n    margin: 0;\n    margin-bottom: 20px;\n    font-weight: 500;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `main_B25hF`,
	"termsandconditionsection": `termsandconditionsection_ebKPp`
};
export default ___CSS_LOADER_EXPORT___;
